import moment from 'moment';

const getDefaultStartDate = () => moment().subtract(7, 'days');
const getDefaultEndDate = () => moment().subtract(1, 'days');

export { getDefaultStartDate, getDefaultEndDate };
